import cx from 'classnames'
import React from 'react'
import PriorityHighIcon from '@material-ui/icons/PriorityHigh'
import CloseIcon from '@material-ui/icons/Close'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import { Box, Dialog, DialogContent, Typography, IconButton, useMediaQuery } from '@material-ui/core'
import Zoom from '@material-ui/core/Zoom'
import useStyles, { LightTooltip } from './Styles'
import { Corner } from 'components/balloon'
import { Balloon, AlertDialog } from 'components'
import { theme } from 'config/constants/theme/theme'
import Provider, { IValidationDialogViewProps } from './Provider'

const ValidationButton: React.FC<IValidationDialogViewProps> = ({
  openDialog,
  openInitiativeAlert,
  isDialogOpenState,
  isInitiativeAlertState,
  navigateToSection,
  navigateToWarningSection,
  getErrorSections,
  getWarningFields,
  getQuestionTitle,
  getQuestionDescription,
  getSectionErrorDescription,
  isVisible
}) => {
  const classes = useStyles({})
  const corner = Corner.BottomRight
  const bgColor = '#f44336'
  const mobileView = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Box className={cx(classes.root, 'validation-button')}>
      {isVisible() && (
        <Box>
          <Balloon
            bgColor={bgColor}
            corner={corner}
            size={mobileView ? 30 : 40}
            borderRadius={mobileView ? '50%' : '50% 50% 50% 0'}
            shadow={Boolean(!mobileView)}
            onClick={event => {
              openDialog('OPEN')
              event.stopPropagation()
            }}
          >
            <LightTooltip
              id="validation-dialog-helper"
              title="Some questions are still incomplete or invalid."
              placement="bottom"
              arrow
              TransitionComponent={Zoom}
              aria-label="incomplete"
            >
              <PriorityHighIcon className={classes.icon} />
            </LightTooltip>
          </Balloon>
          <Dialog
            fullWidth
            maxWidth={'sm'}
            open={isDialogOpenState === 'OPEN'}
            scroll={'paper'}
            onClose={() => openDialog('CLOSED')}
          >
            <MuiDialogTitle disableTypography className={classes.dialogTitle}>
              <Balloon bgColor={bgColor} corner={corner} size={30} shadow={true} className={classes.balloonTitle}>
                <PriorityHighIcon className={classes.iconTitle} />
              </Balloon>
              <Typography id="validation-dialog-title" variant="h6" className={classes.dialogTitleTypography}>
                Your profile ins't fully complete
              </Typography>
              <IconButton
                id="validation-dialog-close-button"
                aria-label="close"
                className={classes.closeButton}
                onClick={() => openDialog('CLOSED')}
              >
                <CloseIcon className={classes.closeIcon} />
              </IconButton>
            </MuiDialogTitle>

            <DialogContent className={classes.dialogContent}>
              <Box className={classes.validationContainer}>
                {getErrorSections().map((section: any, index: number) => (
                  <Box
                    className={cx(classes.questionContainer, classes.questionContainerHover)}
                    onClick={() => navigateToSection(section.id, mobileView)}
                    key={index}
                  >
                    <Balloon
                      bgColor={bgColor}
                      corner={corner}
                      size={26}
                      shadow={true}
                      borderRadius={'50% 50% 50% 0'}
                      className={classes.balloonQuestionTitle}
                    >
                      <PriorityHighIcon className={classes.balloonIcon} />
                    </Balloon>
                    <Box className={classes.questionTitleContainer}>
                      <Typography
                        id={`${index}-validation-dialog-error-question-title-label`}
                        className={classes.questionTitle}
                      >
                        Your <b id={`${index}-validation-dialog-error-question-section-label`}>{section.title}</b>{' '}
                        section must be complete.
                      </Typography>
                      <Typography
                        id={`${index}-validation-dialog-error-question-answer`}
                        className={classes.questionText}
                      >
                        {getSectionErrorDescription(section.id)}
                      </Typography>
                    </Box>
                  </Box>
                ))}
                {getWarningFields().map((attr: any, index: number) => (
                  <Box
                    className={cx(classes.questionContainer, classes.questionContainerHover)}
                    onClick={() => navigateToWarningSection(attr, mobileView)}
                    key={index}
                  >
                    <Balloon
                      bgColor={bgColor}
                      corner={corner}
                      size={26}
                      shadow={true}
                      borderRadius={'50% 50% 50% 0'}
                      className={classes.balloonQuestionTitle}
                    >
                      <PriorityHighIcon className={classes.balloonIcon} />
                    </Balloon>
                    <Box className={classes.questionTitleContainer}>
                      <Typography
                        id={`${index}-validation-dialog-warning-question-title-label`}
                        className={classes.questionTitle}
                      >
                        Your{' '}
                        <b id={`${index}-validation-dialog-warning-question-section-label`}>{getQuestionTitle(attr)}</b>{' '}
                        question must be complete.
                      </Typography>
                      <Typography
                        id={`${index}-validation-dialog-warning-question-title-answer`}
                        className={classes.questionText}
                      >
                        {getQuestionDescription(attr)}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            </DialogContent>
          </Dialog>
        </Box>
      )}
      <AlertDialog
        title="To submit to an initiative all questions must be complete."
        content="You can view questions that need to be completed by clicking on the red ! icon to the right of your profile."
        isOpen={isInitiativeAlertState === 'OPEN'}
        size="sm"
        onClose={() => openInitiativeAlert('CLOSED')}
      />
    </Box>
  )
}

export default () => <Provider>{(state: IValidationDialogViewProps) => <ValidationButton {...state} />}</Provider>
